/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fond_Gray_Newt_WaitInputs */

const en_fond_gray_newt_wait = /** @type {(inputs: Fond_Gray_Newt_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Round × Segment override`)
};

const de_fond_gray_newt_wait = /** @type {(inputs: Fond_Gray_Newt_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Runde × Segment Überschreibung`)
};

/**
* | output |
* | --- |
* | "Round × Segment override" |
*
* @param {Fond_Gray_Newt_WaitInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const fond_gray_newt_wait = /** @type {((inputs?: Fond_Gray_Newt_WaitInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fond_Gray_Newt_WaitInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fond_gray_newt_wait(inputs)
	return de_fond_gray_newt_wait(inputs)
});